import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { OneSelectDropdownModule, OneFormFieldModule } from '@one/angular-kit/form';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatMenuModule } from '@angular/material/menu';
import { OneMenuModule } from '@one/angular-kit/navigation';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { ConfigureFeedbackComponent } from './configure-feedback.component';
import { CfFeedbackTemplateComponent } from './cf-feedback-template/cf-feedback-template.component';
import { CfFeedbackTemplateDialogComponent } from './cf-feedback-template-dialog/cf-feedback-template-dialog.component';
import { CfFtDialogService } from './cf-feedback-template-dialog/cf-ft-dialog.service';
import { CfFeedbackTemplateDropdownComponent } from './cf-feedback-template-dropdown/cf-feedback-template-dropdown.component';
import { CfFeedbackTemplateRadioComponent } from './cf-feedback-template-radio/cf-feedback-template-radio.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [ConfigureFeedbackComponent, CfFeedbackTemplateComponent, CfFeedbackTemplateDialogComponent, CfFeedbackTemplateDropdownComponent, CfFeedbackTemplateRadioComponent],
  imports: [CommonModule, MatMenuModule, OneMenuModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule, OneFormFieldModule, MatCheckboxModule, MatSortModule, DragDropModule, OneTableModule, MatTableModule, MatCardModule, CdkTableModule, MatIconModule, MatListModule, OneListModule, MatButtonModule, OneSelectDropdownModule, FormsModule, ReactiveFormsModule, MatRadioModule, MatSlideToggleModule],
  exports: [ConfigureFeedbackComponent],
  providers: [CfFtDialogService]
})
export class ConfigureFeedbackModule {}
